import React from "react";

const CashBalanceIcon = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.668 10c0-2.948 0-4.422.877-5.406.14-.157.295-.303.463-.435 1.045-.826 2.611-.826 5.743-.826h2.5c3.133 0 4.699 0 5.744.826.167.132.322.278.462.435.878.984.878 2.458.878 5.406 0 2.948 0 4.422-.878 5.406a3.65 3.65 0 01-.462.435c-1.046.826-2.612.826-5.744.826h-2.5c-3.132 0-4.698 0-5.743-.826a3.65 3.65 0 01-.463-.435c-.877-.984-.877-2.458-.877-5.406z"
        stroke="#0469C5"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.128 10a2.083 2.083 0 11-4.167 0 2.083 2.083 0 014.167 0z"
        stroke="#0469C5"
        strokeWidth={1.2}
      />
      <path
        d="M4.168 10h.833M15 10h.833"
        stroke="#0469C5"
        strokeWidth={1.2}
        strokeLinecap="round"
      />
    </svg>
  );
};

export { CashBalanceIcon };
